module.exports = __webpack_public_path__ + "img/login-pic.8fa768e8.png";